<div class="card panel-flat-color secondary-panel date-time-panel">
    <div class="panel-flat-header mb-0">
        <div class="header-icon"><i class="fa fa-calendar"></i></div>
        <h3>Date and Urgency</h3>
    </div>
    <div class="panel-flat-body" style="min-height: 579px">
        <fieldset class="when form-group">
            <legend class="h6 fw-bold">When:</legend>
            <div class="radio">
                <label>
                    <input
                        type="radio"
                        name="action-view-when"
                        [value]="dateTime.AllDates"
                        [checked]="criteria.dateTimeChoice === dateTime.AllDates"
                        [disabled]="criteria.onlyUnscheduled"
                        (change)="setDateTimeChoice(dateTime.AllDates)"
                    />
                    All Dates
                </label>
            </div>
            <div class="radio">
                <label>
                    <input
                        type="radio"
                        name="action-view-when"
                        [value]="dateTime.DueWithinDays"
                        [checked]="criteria.dateTimeChoice === dateTime.DueWithinDays"
                        [disabled]="criteria.onlyUnscheduled"
                        (change)="setDateTimeChoice(dateTime.DueWithinDays)"
                    />
                    Due Within:
                </label>
                <input
                    type="number"
                    min="0"
                    max="365"
                    class="form-control input-inline"
                    style="width: 65px"
                    [ngModel]="criteria.dueWithinDays"
                    [disabled]="criteria.dateTimeChoice !== dateTime.DueWithinDays || criteria.onlyUnscheduled"
                    (ngModelChange)="setNumber('dueWithinDays', $event)"
                />
                days
            </div>
            <div class="radio mt-1 mb-3">
                <label class="mt-2">
                    <input
                        type="radio"
                        name="action-view-when"
                        [value]="dateTime.DueDateRange"
                        [checked]="criteria.dateTimeChoice === dateTime.DueDateRange"
                        [disabled]="criteria.onlyUnscheduled"
                        (change)="setDateTimeChoice(dateTime.DueDateRange)"
                    />
                    Due Date:
                </label>
                <div class="date-range">
                    <weissman-datetime
                        [inputDate]="asDate(criteria.dueDateFrom)"
                        (inputDateChange)="setDate('dueDateFrom', $event)"
                        [dateOnly]="true"
                        [isDisabled]="criteria.dateTimeChoice !== dateTime.DueDateRange || criteria.onlyUnscheduled"
                    />
                    <div>to</div>
                    <weissman-datetime
                        [inputDate]="asDate(criteria.dueDateTo)"
                        (inputDateChange)="setDate('dueDateTo', $event)"
                        [dateOnly]="true"
                        [isDisabled]="criteria.dateTimeChoice !== dateTime.DueDateRange || criteria.onlyUnscheduled"
                    />
                </div>
            </div>
            <div class="mt-3 mb-4">
                <div class="checkbox">
                    <label style="width: unset">
                        <input
                            type="checkbox"
                            [ngModel]="criteria.includeUnscheduled"
                            (ngModelChange)="setBoolean('includeUnscheduled', $event)"
                        />
                        Include Unscheduled
                    </label>
                </div>
                @if (criteria.includeUnscheduled) {
                    <div class="checkbox">
                        <label style="width: unset">
                            <input
                                type="checkbox"
                                [ngModel]="criteria.onlyUnscheduled"
                                (ngModelChange)="setBoolean('onlyUnscheduled', $event)"
                            />
                            Only Unscheduled
                        </label>
                    </div>
                }
            </div>
        </fieldset>

        <div class="form-group checkbox">
            <label class="fw-bold">
                <input
                    type="checkbox"
                    [ngModel]="criteria.useUrgencyFilter"
                    (ngModelChange)="setBoolean('useUrgencyFilter', $event)"
                />
                Urgency:
            </label>
            <select
                class="form-select form-select-sm"
                [ngModel]="criteria.urgencyChoice"
                [disabled]="!criteria.useUrgencyFilter"
                (ngModelChange)="setUrgency($event)"
            >
                @for (urgency of urgencies; track urgency.id) {
                    <option [ngValue]="urgency.id">{{ urgency.display }}</option>
                }
            </select>
        </div>

        <div class="form-group checkbox">
            <label class="fw-bold">
                <input
                    type="checkbox"
                    [ngModel]="criteria.useLastActivityFilter"
                    (ngModelChange)="setBoolean('useLastActivityFilter', $event)"
                />
                Last Activity:
            </label>
            <input
                type="number"
                min="0"
                max="365"
                class="form-control input-inline"
                [ngModel]="criteria.lastActivityFrom"
                [disabled]="!criteria.useLastActivityFilter"
                (ngModelChange)="setNumber('lastActivityFrom', $event)"
                (blur)="validateLastActivity('lastActivityFrom')"
            />
            to
            <input
                type="number"
                min="0"
                max="365"
                class="form-control input-inline"
                [ngModel]="criteria.lastActivityTo"
                [disabled]="!criteria.useLastActivityFilter"
                (ngModelChange)="setNumber('lastActivityTo', $event)"
                (blur)="validateLastActivity('lastActivityTo')"
            />
            days ago.
        </div>

        @if (criteria.thatAreChoice === thatAre.Completed) {
            <fieldset class="form-group ms-2 border-0">
                <legend class="h6 fw-bold">Completed:</legend>
                <div class="radio">
                    <label>
                        <input
                            type="radio"
                            name="action-view-completed"
                            [value]="completed.CompletedWithinLastDays"
                            [checked]="criteria.completedChoice === completed.CompletedWithinLastDays"
                            (change)="setCompletedChoice(completed.CompletedWithinLastDays)"
                        />
                        Within Last:
                    </label>
                    <input
                        type="number"
                        min="0"
                        max="365"
                        class="form-control input-inline"
                        style="width: 65px"
                        [ngModel]="criteria.completedWithinDays"
                        [disabled]="criteria.completedChoice !== completed.CompletedWithinLastDays"
                        (ngModelChange)="setNumber('completedWithinDays', $event)"
                    />
                    days
                </div>
                <div class="radio mt-2">
                    <label class="mt-2">
                        <input
                            type="radio"
                            name="action-view-completed"
                            [value]="completed.DatesProvidedByUser"
                            [checked]="criteria.completedChoice === completed.DatesProvidedByUser"
                            (change)="setCompletedChoice(completed.DatesProvidedByUser)"
                        />
                        Date:
                    </label>
                    <div class="date-range ms-2">
                        <weissman-datetime
                            [inputDate]="asDate(criteria.completedDateFrom)"
                            (inputDateChange)="setDate('completedDateFrom', $event)"
                            [dateOnly]="true"
                            [isDisabled]="criteria.completedChoice !== completed.DatesProvidedByUser"
                        />
                        <div>to</div>
                        <weissman-datetime
                            [inputDate]="asDate(criteria.completedDateTo)"
                            (inputDateChange)="setDate('completedDateTo', $event)"
                            [dateOnly]="true"
                            [isDisabled]="criteria.completedChoice !== completed.DatesProvidedByUser"
                        />
                    </div>
                </div>
                <div class="checkbox">
                    <label style="width: unset">
                        <input
                            type="checkbox"
                            [ngModel]="criteria.includeSkipped"
                            (ngModelChange)="setBoolean('includeSkipped', $event)"
                        />
                        Include Skipped
                    </label>
                </div>
                @if (criteria.includeSkipped) {
                    <div class="checkbox">
                        <label style="width: unset">
                            <input
                                type="checkbox"
                                [ngModel]="criteria.onlySkipped"
                                (ngModelChange)="setBoolean('onlySkipped', $event)"
                            />
                            Only Skipped
                        </label>
                    </div>
                }
            </fieldset>
        }
    </div>
</div>
